@if (bannerState) {
  @if (displayBannerDefault) {
    <div class="banner">
      <app-breadcrumb [itemList]="bannerState.breadcrumbItemList"></app-breadcrumb>
      <h1>{{ bannerState.title }}</h1>
      <p>{{ bannerState.description }}</p>
    </div>
  }

  @if (displayBannerMunhowen) {
    <div class="banner container py-4">
      <div class="fs-1">{{ bannerState.title }}</div>
      @if (mediaBreakpoint >= eMediaBreakpoint.LG) {
        <app-breadcrumb [itemList]="bannerState.breadcrumbItemList"></app-breadcrumb>
      }
    </div>
  }
}
